import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CpinComponent } from '../../../shared/legacy-bookexpress/components/cpin/cpin.component';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { BsDatepickerConfig, BsDaterangepickerDirective } from 'ngx-bootstrap/datepicker';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { offerDetailsComponent } from '../../../shared/legacy-bookexpress/components/offerDetails/offerDetails.component';
import { ActivatedRoute } from '@angular/router';
import { SearchPopComponent } from '../search-pop/search-pop.component';
import { offerDialogComponent } from './offerDialog.component';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import * as locales from 'ngx-bootstrap/locale';
import { AzureTokenBlobPipe } from 'app/shared/pipes/azureBlobToken.pipe';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OfferlistService } from 'modules/shared/legacy-bookexpress/services/OfferList.service';
import { GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';
import { CryptoconvertService } from 'modules/shared/legacy-bookexpress/services/cryptoconvert.service';
import { BookService } from 'modules/shared/legacy-bookexpress/services/book.service';
import { MaintenanceService } from 'modules/shared/legacy-bookexpress/services/maintenance.service';
import { RoomlistService } from 'modules/shared/legacy-bookexpress/services/RoomList.service';
import { SharedService } from 'modules/shared/legacy-bookexpress/services/shared.service';
import { PreloaderService } from 'modules/shared/legacy-bookexpress/services/preloader.service';
import { menuService } from 'modules/shared/legacy-bookexpress/services/menu.service';
import { CasinoPlayerService } from 'modules/shared/legacy-bookexpress/services/casino-player.service';
import { CpinService } from 'modules/shared/legacy-bookexpress/services/cpin.service';
import { ValidateLoyaltyService } from 'modules/shared/legacy-bookexpress/services/validate-loyalty.service';
import { GetOfferApiResponse } from 'app/model/wbe/backend-api-response/get-offer-api-response';
import { Offers } from 'app/model/shared/backend-api-response/offers';
import { BlockedOffers } from 'app/model/wbe/backend-api-response/blocked-offers';
import { DateFunctionConfig } from 'app/model/shared/backend-api-response/date-function-config';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss', './offers-style-handler.component.scss'],
})
export class OffersComponent implements OnInit {
  public tenantID: any;
  public propertyID: any;
  public rGuestBookMessages: RGuestMessages;
  public rGuestBookPermissions: Permissions;
  public assetsURL: string;
  public defaultOfferImageURL: string;
  private tenantId: any;
  private propertyId: any;
  public totalBasicOffers: number;
  public localeData: any;
  public totalCasinoOffers: any;
  public selectedOffer: object;
  public casinoData: any;
  public height: any;
  scrollableDrawer: any = '.scrollableDrawer';
  currentCasinoNumber: any;
  maxNightsAllowed: any;
  minDate: Date;
  casinoData$: BehaviorSubject<Array<any>>;
  public isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
  @Input() ArrDepDate: Array<any> = [];
  @Input() origin: any = 'deafult';
  @Input() casinoNumber: string = '';
  @Input() viewDetailsButton: boolean = true;
  @Input() viewBookButton: boolean = true;
  @Input() viewSelectButton: boolean = false;
  @Input() casinoNumberpanel: string = '';
  @Input() offerValue: any;
  @Input() guestCount: any;
  @Input() navigateFromcalendar: boolean = false;
  @Input() selectedTab = 0;
  @Input() pageFromRoom: boolean = false;
  @Input() viewFilter: boolean = true;
  //not used inputs
  @Input() defaultHeight: number;
  @Output() loginFromOffers = new EventEmitter<boolean>();
  @Output() someEvent = new EventEmitter<string>();
  @Output() callFun: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('dpr')
  private _picker: BsDaterangepickerDirective;
  ArrDate: string = '';
  OfferCode: string = '';
  DepDate: string = '';
  bsConfig: Partial<BsDatepickerConfig>;
  colorTheme = 'theme-dark-blue ';
  casinoError: string = '';
  offerError: string = '';
  @ViewChild('arrPicker')
  private arrDatePicker: MatDatepicker<Date>;
  @ViewChild('depPicker')
  private depDatePicker: MatDatepicker<Date>;

  public basicOffersBackup: Array<any> = [];
  public casinoOffersBackup: Array<any> = [];
  public basicOfferList: Offers[] = [];
  public blockedOfferList: Array<any> = [];
  public casinoOfferList: Array<any> = [];
  checkindisplayBlockDays: Array<any> = [];
  checkincasinoBlockDays: Array<any> = [];
  checkinBlockDays: Array<any> = [];
  casinoList: Array<any> = [];

  public basicOfferPreload: boolean = true;
  public casinoOfferPreload: boolean = true;
  public basicOfferPreloadEnd: boolean = false;
  public stopBasicOfferScroll: boolean = false;
  public isIOS: boolean = false;
  public clearFilter: boolean = true;
  public searchOffer: boolean;
  offerIsCasinoOffer: boolean = false;
  casinoOfferAvailable: boolean = true;
  casinopreload: boolean;
  validCasinoNumber: boolean = false;

  public initialSequence: number = 1;
  public initialTotalCount: number = 1;
  public offerPageCount: number = 1;
  public countryCode: string;
  public IEarrival: any;
  public IEdeparture: any;
  dateFunctionConfig: DateFunctionConfig;
  adultsValue: any;
  childValue: any;
  infantsValue: any;
  juniorValue: any;
  disablePeopleValue: any;
  previousOffer: any;
  private nextSequenceNo = 0;

  constructor(
    public offerService: OfferlistService,
    public appInitializer: LegacyBookInitService,
    public toastr: ToastrService,
    public googleAnalytics: GoogleAnalyticsEventsService,
    public dialog: MatDialog,
    public cryptoConvert: CryptoconvertService,
    private BookService: BookService,
    private MaintenanceService: MaintenanceService,
    public _roomList: RoomlistService,
    private _shared: SharedService,
    private router: Router,
    public snackbar: MatSnackBar,
    private route: ActivatedRoute,
    public PreloaderService: PreloaderService,
    public menuService: menuService,
    public CasinoPlayerService: CasinoPlayerService,
    public CpinService: CpinService,
    private localeService: BsLocaleService,
    public azureBlobToken: AzureTokenBlobPipe,
    public loyaltyService: ValidateLoyaltyService
  ) {
    this.dateFunctionConfig = this.appInitializer?.PropertyData?.dateFunctionConfig;
    var is_ios = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (is_ios) {
      this.isIOS = true;
    }
    this.assetsURL = this.appInitializer?.PropertyData?.UrlMap?.ImageUrl;
    this.localeData = this.appInitializer.localeData;
    this.countryCode = this.appInitializer?.PropertyData?.countryCode;
    if (this.appInitializer.multiGuestType) {
      this.adultsValue = this.appInitializer.guestTypeLimit.findIndex((guest) => guest.key === 'adults');
      this.childValue = this.appInitializer.guestTypeLimit.findIndex((guest) => guest.key === 'children');
      this.infantsValue = this.appInitializer.guestTypeLimit.findIndex((guest) => guest.key === 'infants');
      this.juniorValue = this.appInitializer.guestTypeLimit.findIndex((guest) => guest.key === 'juniors');
      this.disablePeopleValue = this.appInitializer.guestTypeLimit.findIndex((guest) => guest.key === 'discChild');
    }
    // for (const locale in this.localeData) {
    //   if (this.countryCode.toLowerCase() === this.localeData[locale].abbr) {
    //     this.localeService.use(this.countryCode);
    //   }
    // }
    for (const locale in locales) {
      if (this.dateFunctionConfig.dateRangePickerFormat === locales[locale].abbr) {
        this.localeService.use(this.dateFunctionConfig.dateRangePickerFormat);
      }
    }
    this.defaultOfferImageURL = this.appInitializer?.PropertyData?.UrlMap?.defaultOfferImageUrl;
    this.rGuestBookMessages = this.appInitializer?.PropertyData?.rGuestMessages;
    this.rGuestBookPermissions = this.appInitializer?.PropertyData?.permissions;
    this.tenantId = this.appInitializer.gettenantId();
    this.propertyId = this.appInitializer.getpropertyId();
    this.guestCount = this.appInitializer.getguest_count() || 2;

    this.CasinoPlayerService.resetPlayernew.subscribe((dta) => {
      if (dta != 'default') {
        this.casinoData = '';
        this.casinoList = [];
        this.casinoNumber = '';
        this.casinoNumberpanel = '';
        this.CasinoPlayerService.resetPlayernew.next('default');
      }
    });
  }

  ngOnInit() {
    //Google Tag Manager push
    if (!this.pageFromRoom)
      this.googleAnalytics.pushGTAToDataLayer({
        event: 'offersPageLoad',
        page: 'offers',
        casinoId: this.loyaltyService.playerDetails?.casinoNumber || 'NA',
        emailAddress: this.loyaltyService.playerDetails?.emailAddress || 'NA',
      });

    this.googleAnalytics.eventEmitter(
      'page_load',
      'offers',
      'offers_page_loaded',
      `Casino Id - ${this.loyaltyService.playerDetails?.casinoNumber || 'NA'}, Email Address - ${
        this.loyaltyService.playerDetails?.emailAddress || 'NA'
      }`
    );

    $('.mat-drawer').css(
      'background-image',
      `url("${this.appInitializer.PropertyData.UrlMap.ImageUrl}bgimage.png?${this.appInitializer.azureBlobTokenKey}")`
    );
    this.height = $(window).height() - $('nav').height();
    this.casinoOfferAvailable = true;
    this.casinopreload = this.offerService.setCasinoProloader();
    this.basicOfferPreload = this.offerService.setOfferProloader();

    if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-Casino')) {
      let casino = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-Casino'));
      this.casinoNumber = casino.casinoNumber;
      this.casinoOfferAvailable = false;
      //this.selectedTab=1;
    } else {
      this.casinoNumber = '';
    }
    this.searchOffers('offer');
    const dateFormat = moment.localeData(this.dateFunctionConfig?.locale).longDateFormat('L');
    this.bsConfig = Object.assign({
      containerClass: this.colorTheme,
      displayMonths: 1,
      showWeekNumbers: false,
      rangeInputFormat: dateFormat,
      rangeSeparator: ' - ',
    });
    this.casinoData$ = new BehaviorSubject<Array<string>>(this.casinoData);
    this.processConfig(this.appInitializer.configDetailsData);

    if (this.viewFilter) {
      this.route.params.subscribe((params) => {
        this.menuService.routeChange(params);
        console.log('Offer param: ', params);
      });
    }
  }

  navigateToCalendar() {
    let offerCode = this.appInitializer.defaultOffer();
    if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL) {
      offerCode = this.cryptoConvert.convertOfferCode(offerCode, 'encrypt');
    }
    this.menuService.toggleSidebar(false);
    this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCode]);
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    let arrivalDate, departureDate;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if (isHovered && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && 'ontouchstart' in window) {
        console.log(cell);
        if (!arrivalDate) arrivalDate = cell.date;
        else {
          if (moment(cell.date).isAfter(moment(arrivalDate))) {
            departureDate = cell.date;
            setTimeout(() => {
              (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
            }, 100);
          } else {
            arrivalDate = cell.date;
          }
        }
      } else {
        return dayHoverHandler(hoverEvent);
      }
      if (arrivalDate && departureDate) return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  onResize(event) {
    this.height = $(window).height() - $('nav').height();
  }
  getBasicOffers(Sequence, Total) {
    // if (typeof casinoNumber == "undefined") {
    //   casinoNumber = "";
    // }  ,casinoNumber, casinoTrigger
    // if (typeof casinoTrigger == "undefined") {
    //   casinoTrigger = "";
    // }
    this.offerService.getOffers(Sequence, Total, '', this.ArrDate, this.DepDate, this.OfferCode, '', '').subscribe(
      (data: GetOfferApiResponse) => {
        if (data['Success']) {
          this.proccessBasicOffers(data);
          this.offerError = '';
        } else if (this.casinoList.length <= 0) {
          if (
            data['ErrorMessage'] == 'Offer requested can not be found.' ||
            data['ErrorMessage'] == 'Offer Not Found' ||
            data['ErrorMessage'] == 'Offer Not Available'
          ) {
            //this.toastr.error("Offer " + this.OfferCode + " cannot be found.");
            this.offerError = 'Offer ' + this.OfferCode + ' cannot be found.';
          } else {
            //this.toastr.error(data["ErrorMessage"]);
            this.offerError = data['ErrorMessage'];
          }
          //this.ArrDate="";
          //this.DepDate="";
          //this.OfferCode="";
          //this.ArrDepDate=[];
          //this.searchOffers('offer');
        } else {
          this.basicOfferList = [];
          this.totalBasicOffers = 0;
          this.offerError = 'Currently the Best Offers are not available, kindly try the Casino Offers.';
        }
      },

      (error) => {
        // this.toastr.error(error["ErrorMessage"]);
        //this.ArrDate="";
        //this.DepDate="";
        //this.OfferCode="";
        //this.ArrDepDate=[];
        //this.searchOffers('offer');
      }
    );
  }

  proccessBasicOffers(data: GetOfferApiResponse) {
    if (data['offers']) {
      this.nextSequenceNo = data.nextSequenceNo ? data.nextSequenceNo : 0;
      const basicOfferIndex = this.basicOfferList.findIndex((x) => x.offer === data['offers'][0]?.offer);
      if (basicOfferIndex === -1) {
        this.basicOfferList.push(...data['offers']);
      } else {
        this.basicOfferList = [...data['offers']];
      }
      if (this.basicOfferList.length > 0 && this.casinoList.length <= 0) {
        this.selectedTab = 0;
      }
      console.log('BASIC OFFERS Count: ', this.basicOfferList);
      const blockedOfferIndex = this.blockedOfferList.findIndex((x) => x.offer === data['blockedOffers'][0]?.offer);
      if (blockedOfferIndex === -1) {
        this.blockedOfferList.push(...data['blockedOffers']);
      } else {
        this.blockedOfferList = [...data['blockedOffers']];
      }

      console.log('Blocked OFFERS Count: ', this.blockedOfferList);
      //this.basicOfferList = this.basicOfferList.concat(this.blockedOfferList);
      this.stopBasicOfferScroll = false;
      this.basicOfferPreload = false;
      this.totalBasicOffers = data['totalOffers'];

      if (this.basicOfferList.length <= 0 && this.blockedOfferList.length > 0) {
        this.basicOfferList = this.basicOfferList.concat(this.blockedOfferList);
      }

      if (this.totalBasicOffers > 0 && this.searchOffer) {
        if (this.OfferCode.length > 0) {
          this.clearFilter = false;
        }
        if (Array.isArray(this.ArrDepDate)) {
          if (this.ArrDepDate.length > 0) {
            this.clearFilter = false;
          }
        }
      }
      this.googleAnalytics.viewOffersList(
        this.basicOfferList,
        this.propertyId,
        this.tenantId,
        this.appInitializer?.PropertyData?.currencyCode,
        this.casinoNumber
      );
    }
  }

  onbasicOfferListScroll() {
    // alert('scrolled')
    if (!this.stopBasicOfferScroll) {
      if (this.basicOfferList.length + this.blockedOfferList.length + 1 <= this.totalBasicOffers) {
        const nextSequenceNo =
          this.nextSequenceNo > 0 ? this.nextSequenceNo : this.basicOfferList.length + this.blockedOfferList.length + 1;
        this.getBasicOffers(nextSequenceNo, this.totalBasicOffers);
        this.stopBasicOfferScroll = true;
        this.basicOfferPreload = true;
      } else {
        this.stopBasicOfferScroll = true;
        this.basicOfferPreload = false;
        this.basicOfferPreloadEnd = true;
        this.basicOfferList = this.basicOfferList.concat(this.blockedOfferList);
      }
    }
  }
  errorofferImageHandler(event, offerIndex, imgIndex, type) {
    if (this.rGuestBookPermissions.functionalPermissions.blockDefaultImage) {
      if (type == 'best') {
        this.basicOfferList[offerIndex].offerImageList.splice(imgIndex, 1);
      } else {
        this.casinoList[offerIndex].offerImageList.splice(imgIndex, 1);
      }
    } else {
      event.target.src = this.azureBlobToken.transform(this.defaultOfferImageURL);
    }
  }

  validatedates(selectedDate: any) {
    if (Array.isArray(selectedDate)) {
      if (selectedDate.length > 0) {
        let ArrivalDate: Date = selectedDate[0];
        let DepartureDate: Date = selectedDate[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDate(ArrivalDate);
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDate(DepartureDate);
        let outArrivalDate = ArrDate;
        let outDepartureDate = ArrDate;
        var timeDiff = Math.abs(ArrivalDate.getTime() - DepartureDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        this.ArrDate = ArrDate;
        this.DepDate = DepDate;
        let arrDate = this.ArrDate.split('-');
        let depDate = this.DepDate.split('-');
        this.IEarrival = new Date(+arrDate[0], +arrDate[1] - 1, +arrDate[2]);
        this.IEdeparture = new Date(+depDate[0], +depDate[1] - 1, +depDate[2]);
        if (this.maxNightsAllowed != 0 && diffDays > this.maxNightsAllowed) {
          this.ArrDepDate = [];
          this.ArrDate = '';
          this.DepDate = '';
          this.IEarrival = '';
          this.IEdeparture = '';
          let errordate = this.rGuestBookMessages.offer.offerMessage3 + this.maxNightsAllowed + ' day(s)';
          // if ($("#toast-container").html() == undefined) {
          //   this.toastr.error(errordate);
          // }
          this.toastr.error(errordate);
        } else {
          if (this.rGuestBookPermissions.functionalPermissions.enableAutoSearch) {
            this.searchOffers('offer');
          }
        }
      }
    }
  }

  offerCodeSearch() {
    if (this.previousOffer != this.OfferCode) {
      if (this.rGuestBookPermissions.functionalPermissions.enableAutoSearch) {
        this.searchOffers('offer');
      }
    }
  }

  offerCodeEntry(event: any) {
    if (event.target.value === '') {
      this.basicOfferPreload = false;
    } else {
      if (this.previousOffer !== event.target.value) {
        this.basicOfferPreload = false;
      }
    }
  }

  storePrviousOffer() {
    this.previousOffer = this.OfferCode;
    console.log('previous offer', this.previousOffer);
  }

  getDate(UnformattedDate: Date) {
    let mm, dd, yyyy;
    mm = UnformattedDate.getMonth() + 1;
    mm = this.checkFormat(mm);
    dd = UnformattedDate.getDate();
    dd = this.checkFormat(dd);
    yyyy = UnformattedDate.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  checkFormat(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  public searchOffers(navData) {
    if (navData == 'sideNav') {
      this.OfferCode = '';
      this.basicOffersBackup = [];
      this.casinoOffersBackup = [];
      this.basicOfferList = [];
      this.blockedOfferList = [];
      this.casinoOfferList = [];
      this.totalBasicOffers = 0;
      this.totalCasinoOffers = 0;
    }

    if (this.OfferCode.length > 0 && (this.basicOfferList.length > 0 || this.casinoList.length > 0)) {
      if (this.basicOfferList.length > 0) {
        if (this.basicOffersBackup.length <= 0) this.basicOffersBackup = this.basicOfferList;
        let searchBasicOfferList = [];
        for (var i = 0; i < this.basicOffersBackup.length; i++) {
          if (this.basicOffersBackup[i].offer.toLowerCase() == this.OfferCode.toLowerCase()) {
            searchBasicOfferList.push(this.basicOffersBackup[i]);
          }
        }
        this.basicOfferList = searchBasicOfferList;
      }
      if (this.casinoList.length > 0) {
        if (this.casinoOffersBackup.length <= 0) this.casinoOffersBackup = this.casinoOfferList;
        let searchCasinoOfferList = [];
        for (var i = 0; i < this.casinoOffersBackup.length; i++) {
          if (this.casinoOffersBackup[i].offer.toLowerCase() == this.OfferCode.toLowerCase()) {
            searchCasinoOfferList.push(this.casinoOffersBackup[i]);
          }
        }
        this.casinoList = searchCasinoOfferList;
      }
      if (this.basicOfferList.length > 0 && this.casinoList.length <= 0) {
        this.selectedTab = 0;
      }
      if (this.casinoList.length > 0 || this.basicOfferList.length > 0) {
        this.clearFilter = false;

        if (this.casinoList.length == 0) {
          this.casinoOfferAvailable = false;
        }

        if (this.basicOfferList.length == 0) {
          this.offerError = 'Currently the Best Offers are not available, kindly try the Casino Offers.';
          this.totalBasicOffers = 0;
        } else {
          this.totalBasicOffers = this.basicOfferList.length;
        }
        this.casinoError = '';
        return;
      } else {
        if (this.basicOfferList.length <= 0) this.casinoError = 'Offer ' + this.OfferCode + ' cannot be found';
        else this.casinoError = '';
      }
    }

    this.initialSequence = 1;
    this.initialTotalCount = 1;
    this.offerPageCount = 1;
    this.basicOfferList = [];
    this.checkinBlockDays = [];
    this.casinoOffersBackup = [];
    this.basicOffersBackup = [];
    this.blockedOfferList = [];
    this.basicOfferPreload = true;
    this.basicOfferPreloadEnd = false;
    this.totalBasicOffers = 0;
    this.offerError = '';
    this.casinoError = '';
    if (this.viewSelectButton == true) {
      // this.top = "10";
    }
    if (this.OfferCode.length > 0 || this.ArrDepDate.length > 0) {
      this.clearFilter = false;
    }
    this.searchOffer = true;
    if (Array.isArray(this.ArrDepDate)) {
      if (this.ArrDepDate.length > 1) {
        let ArrivalDate: Date = this.ArrDepDate[0];
        let DepartureDate: Date = this.ArrDepDate[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDate(ArrivalDate);
        this.ArrDate = ArrDate;
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDate(DepartureDate);
        this.DepDate = DepDate;
        let arrDate = this.ArrDate.split('-');
        let depDate = this.DepDate.split('-');
        this.IEarrival = new Date(+arrDate[0], +arrDate[1] - 1, +arrDate[2]);
        this.IEdeparture = new Date(+depDate[0], +depDate[1] - 1, +depDate[2]);
        var outArrivalDate = ArrDate;
        var outDepartureDate = DepDate;
      } else {
        this.ArrDepDate = [];
      }
    }
    if (this.OfferCode.length > 0) {
      var outOfferCode = this.OfferCode.replace(/#/g, '%23');
      this.OfferCode = outOfferCode;
      this.offerError = '';
    }
    if (this.casinoNumber.length > 0 || this.casinoNumberpanel.length > 0) {
      if (this.casinoNumber.length <= 0 && this.validCasinoNumber) {
        this.casinoNumber = this.casinoNumberpanel;
      }
      var outCasinoNumber = this.casinoNumber.replace(/#/g, '%23');
      this.offerIsCasinoOffer = false;
      this.searchCasinoOffers((outArrivalDate, outDepartureDate, outOfferCode, outCasinoNumber) => {
        outCasinoNumber = '';
        if (this.OfferCode != outOfferCode) {
          outOfferCode = this.OfferCode;
        }
        if (this.ArrDate != outArrivalDate) {
          outArrivalDate = this.ArrDate;
        }
        if (this.DepDate != outDepartureDate) {
          outDepartureDate = this.DepDate;
        }
        if (this.offerIsCasinoOffer == true) {
          outOfferCode = '';
        }
        if (typeof outArrivalDate == 'undefined') {
          outArrivalDate = '';
        }
        if (typeof outDepartureDate == 'undefined') {
          outDepartureDate = '';
        }

        if (typeof outCasinoNumber == 'undefined') {
          outCasinoNumber = '';
        }
        if (typeof outOfferCode == 'undefined') {
          outOfferCode = '';
        }
        this.initialSequence = 1;
        this.initialTotalCount = 1;
        this.offerPageCount = 1;
        this.basicOfferList = [];
        this.checkinBlockDays = [];
        this.blockedOfferList = [];
        this.basicOfferPreload = true;
        this.basicOfferPreloadEnd = false;
        //this.baseArray = [];

        //this.bottomline = undefined;
        //this.scrollblock = false;

        // this.data1 = outArrivalDate;
        // this.data2 = outDepartureDate;
        // this.data3 = outOfferCode;
        // this.data4 = outCasinoNumber;
        // if(this.vc)
        // this.vc.ngAfterViewInit();
        this.getBasicOffers(this.initialSequence, this.initialTotalCount);
      });
    }
    if (this.casinoNumber.length <= 0 && this.casinoNumberpanel.length <= 0) {
      this.casinoList = [];
      if (!this.viewSelectButton) this.selectedTab = 0;
      // this.overflow_x = "hidden";
      // this.overflow_y = "hidden";
      // this.overoffersflow_y_touch = "hidden";
      outCasinoNumber = '';
      if (typeof outArrivalDate == 'undefined') {
        outArrivalDate = '';
      }
      if (typeof outDepartureDate == 'undefined') {
        outDepartureDate = '';
      }

      if (typeof outCasinoNumber == 'undefined') {
        outCasinoNumber = '';
      }
      if (typeof outOfferCode == 'undefined') {
        outOfferCode = '';
      }
      this.initialSequence = 1;
      this.initialTotalCount = 1;
      this.offerPageCount = 1;
      this.basicOfferList = [];
      this.checkinBlockDays = [];
      this.blockedOfferList = [];
      this.basicOfferPreload = true;
      this.basicOfferPreloadEnd = false;
      //this.baseArray = [];

      //this.bottomline = undefined;
      //this.scrollblock = false;

      // this.data1 = outArrivalDate;
      // this.data2 = outDepartureDate;
      // this.data3 = outOfferCode;
      // this.data4 = outCasinoNumber;
      // if(this.vc)
      // this.vc.ngAfterViewInit();
      this.getBasicOffers(this.initialSequence, this.initialTotalCount);
    }

    this.googleAnalytics.eventEmitter(
      'search_button',
      'offers',
      'search_button_clicked',
      `selection : ${this.ArrDate} - ${this.DepDate}, offer: ${this.OfferCode}`
    );
  }

  searchCasinoOffers(callback) {
    if (this.rGuestBookPermissions.functionalPermissions.casinoOffers) {
      //  this.casinoError = "";
      if (this.casinoNumberpanel.length > 0 || this.casinoNumber.length > 0) {
        if (this.validCasinoNumber) var outcasinoNumberpanel = this.casinoNumber || this.casinoNumberpanel;
        else var outcasinoNumberpanel = this.casinoNumber;
        if (Array.isArray(this.ArrDepDate)) {
          if (this.ArrDepDate.length > 1) {
            let ArrivalDate: Date = this.ArrDepDate[0];
            let DepartureDate: Date = this.ArrDepDate[1];
            ArrivalDate = new Date(ArrivalDate);
            let ArrDate = this.getDate(ArrivalDate);
            DepartureDate = new Date(DepartureDate);
            let DepDate = this.getDate(DepartureDate);
            var outArrivalDate = ArrDate;
            var outDepartureDate = DepDate;
          }
        }
        if (this.OfferCode.length > 0) {
          var outOfferCode = this.OfferCode;
          this.offerError = '';
        }
        if (typeof outArrivalDate == 'undefined') {
          outArrivalDate = '';
        }
        if (typeof outDepartureDate == 'undefined') {
          outDepartureDate = '';
        }
        if (typeof outcasinoNumberpanel == 'undefined') {
          outcasinoNumberpanel = '';
        }
        if (typeof outOfferCode == 'undefined') {
          outOfferCode = '';
        }
        if (this.casinoNumberpanel.length > 0 && this.validCasinoNumber) {
          this.casinoNumber = this.casinoNumberpanel;
        }
        this.casinopreload = true;
        this.casinoList = [];
        outcasinoNumberpanel = outcasinoNumberpanel.replace(/#/g, '%23');
        outOfferCode = outOfferCode.replace(/#/g, '%23');
        /*  if (this.casinoNumberpanel.length > 0) {
           outOfferCode = "";
         } */

        var valid_casinno = /^[ A-Za-z0-9_@./#&+-]*$/;
        if (outcasinoNumberpanel != '' && valid_casinno.test(outcasinoNumberpanel)) {
          this.offerService.casinoOffers(outArrivalDate, outDepartureDate, outOfferCode, outcasinoNumberpanel, true).subscribe(
            (result) => {
              this.processCasinoOffers(result);
              callback();
            },
            (error) => {
              if (this.offerService.errorMessage == 'Casino Account Number is not valid.') {
                if ($('#toast-container').html() == undefined) {
                  this.toastr.error(this.offerService.errorMessage);
                }
                this.casinopreload = false;
                //this.casinoNumber = "";
                this.OfferCode = '';
                this.casinoNumberpanel = '';
                //this.overflow_x = "hidden";
                //this.overflow_y = "hidden";
                //this.overoffersflow_y_touch = "hidden";
              }
            }
          );
        } else {
          this.casinoNumber = '';
          this.casinoNumberpanel = '';
          this.casinopreload = false;
          if ($('#toast-container').html() == undefined) {
            this.toastr.error('Invalid Casino#');
          }
        }
      }
    } else {
      callback();
    }
  }
  tabIndexChange(tabIndex) {
    this.selectedTab = tabIndex;
  }
  processConfig(data) {
    if (data == null || !data.Success) {
      data.service = 'Propery Config service';
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      this.MaintenanceService.putMaintenanceData(data);
      this.router.navigate(['/wbe/maintenance/' + this.tenantId + '/' + this.propertyId]);
    } else {
      this.maxNightsAllowed = data.maxNightsAllowed;
      let localDate = data.currentHotelDate;
      let yyyy = data.currentHotelDate.slice(0, 4);
      let mm = data.currentHotelDate.slice(5, 7);
      if (mm > 0) mm = mm - 1;
      let dd = data.currentHotelDate.slice(8, 10);
      this.minDate = new Date(yyyy, mm, dd);
      console.log(this.minDate);
    }
  }
  private processCasinoOffers = (casOffers) => {
    /* Test for no offers scenario  offers.offers.length = 0; */
    if (casOffers.Success == true) {
      this.casinoOfferAvailable = true;
      if (casOffers.offers.length <= 0) {
        if (this.OfferCode.length <= 0) {
          if ($('#toast-container').html() == undefined) {
            this.toastr.warning('No casino offers found');
          }
        }
        if (!this.viewSelectButton) {
          this.selectedTab = 0;
        }

        this.casinopreload = false;
        // this.casinoNumber = "";
        this.casinoNumberpanel = '';
        if (this.basicOfferList.length <= 0) this.casinoError = 'Offer ' + this.OfferCode + ' cannot be found.';
        else this.casinoError = '';
      } else {
        this.selectedTab += 1;
        /*       casOffers.offers = casOffers.offers.sort(function(a, b) {
                return b.isOfferValid - a.isOfferValid;
              }); */
        // this.overflow_x = "hidden";
        // this.overflow_y = "auto";
        // this.overoffersflow_y_touch = "touch";
        this.casinopreload = false;
        this.casinoList = casOffers.offers;

        this.casinoList = this.casinoList.concat(casOffers.blockedOffers);
        for (let y = 0; y < this.casinoList.length; y++) {
          if (this.casinoList[y].offer == this.OfferCode.toUpperCase()) {
            this.offerIsCasinoOffer = true;
          }
        }
        this.casinoError = '';
      }
      this.googleAnalytics.viewOffersList(
        this.basicOfferList,
        this.propertyId,
        this.tenantId,
        this.appInitializer?.PropertyData?.currencyCode,
        this.casinoNumber
      );
    } else {
      this.casinopreload = false;
      this.casinoOfferAvailable = false;
      if (this.basicOfferList.length <= 0) this.casinoError = 'Offer ' + this.OfferCode + ' cannot be found.';
      else this.casinoError = '';
    }
  };

  getOfferDetails(offer) {
    this.googleAnalytics.eventEmitter('page_load', 'offers', 'offer_viewed', offer.offer);

    this.selectedOffer = offer;
    if (offer.casinoNumberRequired) {
      this.checkindisplayBlockDays = this.checkincasinoBlockDays;
    } else {
      this.checkindisplayBlockDays = this.checkinBlockDays;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = offer;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '500px';
    dialogConfig.height = 'auto';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.panelClass = 'dgPanel';
    dialogConfig.backdropClass = 'dgBackdrop';
    let dialogRef = this.dialog.open(offerDetailsComponent, dialogConfig);

    const sub = dialogRef.componentInstance.onAdd.subscribe((result) => {
      console.log(result);
      this.BookService.changeOffer(result.offer);
      this._shared.offerNameCalendar = result.offer;
      this._shared.offerDescriptionCalendar = result.offerDescription;
      this.someEvent.emit(this.casinoNumber || this.casinoNumberpanel);
      if (this.casinoNumber || this.casinoNumberpanel) {
        this.loginFromOffers.emit(true);
      }
      this.callFun.emit();
      let offerCodeData;
      offerCodeData = offer.offer;
      if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL)
        offerCodeData = this.cryptoConvert.convertOfferCode(offer.offer, 'encrypt');
      if (this.rGuestBookPermissions.routePermissions.calendar && this.origin == 'calendar')
        this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCodeData]);
      else {
        if (this.ArrDate && this.DepDate) {
          //this.router.navigate(["wbe/room", this.tenantId, this.propertyId, this.ArrDate, this.DepDate, offerCodeData, this.guestCount]);
          if (this.appInitializer.multiGuestType) {
            let parameterObj = {};
            this.appInitializer.guestTypeLimit.forEach((element) => {
              if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
                parameterObj[element['key']] = element['selectedValue'];
              }
            });
            console.log(parameterObj);
            this.router.navigate(
              [
                'wbe/room',
                this.tenantId,
                this.propertyId,
                this.ArrDate,
                this.DepDate,
                offerCodeData,
                this.appInitializer.guestTypeLimit[this.adultsValue].selectedValue
                  ? this.appInitializer.guestTypeLimit[this.adultsValue].selectedValue
                  : 1,
              ],
              { queryParams: parameterObj }
            );
          } else {
            this.router.navigate(['wbe/room', this.tenantId, this.propertyId, this.ArrDate, this.DepDate, offerCodeData, this.guestCount]);
          }
        } else {
          var casinoNumber = this.casinoNumberpanel || this.casinoNumber;
          var offerCode = offer.offer;
          var selectedOffer = offer;
          var checkinBlockDays;
          if (offer.casinoNumberRequired) {
            checkinBlockDays = this.checkincasinoBlockDays;
          } else {
            checkinBlockDays = this.checkinBlockDays;
          }
          this.dialog.open(SearchPopComponent, {
            maxHeight: '64vh', //overrides default height of dialog
            disableClose: true,
            data: { offerDetails: offerCode, casinoNumber: casinoNumber, checkinBlockDays: checkinBlockDays, selectedOffer: selectedOffer },
            position: { top: '1%' },
            width: '600px',
            backdropClass: 'backdropBackground',
          });
        }
      }
    });
    dialogRef.afterClosed().subscribe((data) => {
      $('body').css('overflow', 'initial');
    });
  }

  checkAndBook(offer) {
    $('html').css('overflow', 'auto');
    // $('body').css('overflow', 'auto');
    if (this.ArrDepDate.length > 0) {
      this.someEvent.emit(this.casinoNumber || this.casinoNumberpanel);
      localStorage.setItem('casinoNumber', this.casinoNumber || this.casinoNumberpanel);
      this.BookService.changeOffer(offer.offerDescription);

      if (offer.offer == this.offerValue && this.viewSelectButton) {
        this.callFun.emit();
        let offerCodeData;
        if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL)
          offerCodeData = this.cryptoConvert.convertOfferCode(offer.offer, 'encrypt');
        else offerCodeData = offer.offer;
        this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCodeData]);
      }
      if (!this.navigateFromcalendar) {
        let data;
        data = {
          status: true,
          value: this.rGuestBookMessages.offer.offerMessage4,
        };
        this.PreloaderService.sendData(data);
        let offerCodeData;
        if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL)
          offerCodeData = this.cryptoConvert.convertOfferCode(offer.offer, 'encrypt');
        else offerCodeData = offer.offer;
        // this.router.navigate(["wbe/room", this.tenantId, this.propertyId, this.ArrDate, this.DepDate, offerCodeData, this.guestCount]);
        if (this.appInitializer.multiGuestType) {
          let parameterObj = {};
          this.appInitializer.guestTypeLimit.forEach((element) => {
            if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
              parameterObj[element['key']] = element['selectedValue'];
            }
          });
          console.log(parameterObj);
          this.router.navigate(
            [
              'wbe/room',
              this.tenantId,
              this.propertyId,
              this.ArrDate,
              this.DepDate,
              offerCodeData,
              this.appInitializer.guestTypeLimit[this.adultsValue].selectedValue
                ? this.appInitializer.guestTypeLimit[this.adultsValue].selectedValue
                : 1,
            ],
            { queryParams: parameterObj }
          );
        } else {
          this.router.navigate(['wbe/room', this.tenantId, this.propertyId, this.ArrDate, this.DepDate, offerCodeData, this.guestCount]);
        }
      } else {
        this.router.navigate(['wbe/calendar', this.tenantId, this.propertyId]);
      }
    } else if (this.navigateFromcalendar) {
      this.BookService.changeOffer(offer.offerDescription);
      this._shared.offerNameCalendar = offer.offer;
      this._shared.offerDescriptionCalendar = offer.offerDescription;
      let data = {
        arrivalDate: '',
        departureDate: '',
        offerCode: offer.offer,
        guestCount: '',
        rooms: '',
      };
      this._shared.roomChange(data);
      this.someEvent.emit(this.casinoNumber || this.casinoNumberpanel);
      this.callFun.emit();
      let offerCodeData;
      if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL)
        offerCodeData = this.cryptoConvert.convertOfferCode(offer.offer, 'encrypt');
      else offerCodeData = offer.offer;
      this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCodeData]);
    } else {
      var casinoNumber = this.casinoNumberpanel || this.casinoNumber;
      var offerCode = offer.offer;
      var selectedOffer = offer;
      var checkinBlockDays;
      if (offer.casinoNumberRequired) {
        checkinBlockDays = this.checkincasinoBlockDays;
      } else {
        checkinBlockDays = this.checkinBlockDays;
      }
      this.dialog.open(SearchPopComponent, {
        disableClose: true,
        data: { offerDetails: offerCode, casinoNumber: casinoNumber, checkinBlockDays: checkinBlockDays, selectedOffer: selectedOffer },
        position: { top: '1.7%' },
        width: '600px',
        backdropClass: 'backdropBackground',
        panelClass: ['custom-mat-dialog-body'],
      });
    }
  }

  clear_Filter() {
    this.ArrDepDate = [];
    this.ArrDate = '';
    this.DepDate = '';
    this.IEarrival = '';
    this.IEdeparture = '';
    //this.casinoNumber = "";
    // this.casinoNumberpanel = "";
    //  localStorage.removeItem(this.tenantId + '-' + this.propertyId+ '-' +"casinoItems");
    this.OfferCode = '';
    this.searchOffers('offer');
    this.clearFilter = true;
  }

  onCasinoKeydown(event) {
    if (event.key === 'Enter') {
      this.openDialog('panel');
    }
  }

  openDialog(mode) {
    if (
      typeof localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn') != 'undefined' &&
      JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn')) != null
    ) {
      let logindetials = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn'));
      if (logindetials.casinoNumber) {
        // alert(this.rGuestBookMessages.offer.offerMessage2)
      }
    } else {
      let casinoNumber;
      if (mode == 'panel') {
        casinoNumber = this.casinoNumberpanel;
      } else if (mode == 'window') {
        casinoNumber = this.casinoNumber;
      }
      console.log('entered Casino number is : ' + casinoNumber);
      if (this.appInitializer?.PropertyData?.casinoValReq) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.position = {
          top: '10px',
        };
        dialogConfig.disableClose = true;

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
          casinoNumber: casinoNumber,
        };
        const dialogRef = this.dialog.open(CpinComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((data) => {
          console.log('Dialog output:', data);
          if (data == 'success') {
            this.getCasinoPlayer(this.casinoNumberpanel);
          }
        });
      } else {
        this.getCasinoPlayer(casinoNumber);
        //this.searchOffers('offer');
      }
    }
  }

  public getCasinoPlayer(casinoNumber) {
    var valid_casinno = /^[ A-Za-z0-9_@./#&+-]*$/;

    if (casinoNumber != '' && valid_casinno.test(casinoNumber)) {
      if (!this.appInitializer?.PropertyData?.casinoValReq)
        this.PreloaderService.sendData({ status: true, value: this.rGuestBookMessages.offer.offerMessage7 });
      this.currentCasinoNumber = casinoNumber;
      this.CasinoPlayerService.getCasinoPlayerDetails(casinoNumber, this.tenantId).then((result) => {
        let appendArray: any;
        appendArray = [];
        appendArray = result;
        if (!appendArray.Success) {
          //      localStorage.removeItem(this.tenantId + '-' + this.propertyId+ '-' +"casinoItems")
          //if ($("#toast-container").html() == undefined) {
          this.toastr.error(
            appendArray.ErrorMessage ||
              this.rGuestBookMessages.commonVerbiage.loyaltyApiNoResponseError ||
              'Something went wrong. Please try again later'
          );
          //}
          if (!this.appInitializer?.PropertyData?.casinoValReq) this.PreloaderService.sendData({ value: 'No preload', status: false });
          this.CpinService.loginPlayerDetails.next('default');
          this.CasinoPlayerService.userData$.next('data');
          this.casinoNumber = '';
          this.casinoNumberpanel = '';
          this.CasinoPlayerService.removePlayerToken();
          localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-Casino');
          localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn');
          this._roomList.casinoPlayerloginCall.next(false);
          this._roomList.offerSelectedfromoffersAPI.next(true);
          sessionStorage.removeItem(this.tenantId + '-' + this.propertyId + '-userSelectedOffer');
          return false;
        } else {
          this.snackbar.open(this.rGuestBookMessages.profile.profileMessage6, '', {
            duration: 3000,
          });
          this.casinoNumber = casinoNumber;
          this.casinoNumberpanel = casinoNumber;
          this.CasinoPlayerService.updateCasinoPopUp(appendArray);
          this.casinoData = appendArray;
          this.casinoData$.next(this.casinoData);

          let data = {
            casinoNumber: casinoNumber,
            token: 1,
          };
          localStorage.setItem(this.tenantId + '-' + this.propertyId + '-Casino', JSON.stringify(data));
          localStorage.setItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn', JSON.stringify(data));
          let casData = {
            casinoNumber: casinoNumber,
            count: 1,
            token: 1,
            sessionts: new Date().getTime(),
          };
          this.CpinService.casinoTokenValidatios(casData);
          if (!this.appInitializer?.PropertyData?.casinoValReq) this.PreloaderService.sendData({ value: 'No preload', status: false });

          this.validCasinoNumber = true;
          this.searchOffers('offer');
        }
      });
    } else {
      $('.toast-custom').hide();
      if ((casinoNumber != '' && $('#toast-container').html() == undefined) || !valid_casinno.test(casinoNumber)) {
        this.toastr.error('Invalid Casino#');
        $('.toast-custom').show();
      }
      this.casinoNumber = '';
      this.casinoNumberpanel = '';
      if (!this.appInitializer?.PropertyData?.casinoValReq) this.PreloaderService.sendData({ value: 'No preload', status: false });
    }
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(offerDialogComponent, {
      width: '100vw',
      data: {
        minDate: this.minDate,
        ArrDepDate: this.ArrDepDate,
        maxNightsAllowed: this.maxNightsAllowed,
        OfferCode: this.OfferCode,
        pageFromRoom: this.pageFromRoom,
        errorMsg: this.rGuestBookMessages.offer.offerMessage3,
        onShowPicker: this.onShowPicker.bind(this),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        //this.ArrDate = result.ArrDate;
        //this.DepDate = result.DepDate;
        //this.ArrDepDate = result.ArrDepDate;
        this.OfferCode = result.OfferCode;
        this.ArrDepDate = result.ArrDepDate;
        this.searchOffers('offer');
      }
    });
  }

  validateArrDate(arrDate) {
    let arrDate1;
    let depDate1;
    arrDate1 = moment(arrDate).format('YYYY-MM-DD');
    depDate1 = this.DepDate ? moment(this.DepDate).format('YYYY-MM-DD') : '';
    let arr = arrDate1.split('-');
    let dep = depDate1 ? depDate1.split('-') : '';
    this.ArrDepDate = [new Date(+arr[0], +arr[1] - 1, +arr[2]), dep ? new Date(+dep[0], +dep[1] - 1, +dep[2]) : ''];
    this.ArrDate = arrDate1;
    this.IEarrival = new Date(+arr[0], +arr[1] - 1, +arr[2]);
    if (this.DepDate && this.rGuestBookPermissions.functionalPermissions.enableAutoSearch) {
      this.searchOffers('offer');
    }
    setTimeout(() => {
      this.depDatePicker.open();
    }, 500);
  }
  validateDepDate(depDate) {
    let arrDate2;
    let depDate2;
    arrDate2 = this.ArrDate ? moment(this.ArrDate).format('YYYY-MM-DD') : '';
    depDate2 = moment(depDate).format('YYYY-MM-DD');
    let arr = arrDate2 ? arrDate2.split('-') : '';
    let dep = depDate2.split('-');
    this.ArrDepDate = [arr ? new Date(+arr[0], +arr[1] - 1, +arr[2]) : '', new Date(+dep[0], +dep[1] - 1, +dep[2])];
    this.DepDate = depDate2;
    this.IEdeparture = new Date(+dep[0], +dep[1] - 1, +dep[2]);
    if (this.ArrDate && this.rGuestBookPermissions.functionalPermissions.enableAutoSearch) {
      this.searchOffers('offer');
    }
  }
}
